import React from 'react';
import { useTranslation } from 'react-i18next';
import { deviceTypes, deviceSubTypes } from '../../../utils/mappings';
import unknownCredential from '../../../images/lock.svg';
import { StyledImage, StyledLargeHorizontalImage } from '../../../styles/common';

const DeviceType = ({ device }) => {
    const { t } = useTranslation();
    const { type, serial } = device || {};
    const idprimepivv4Type =  device.subType === "idprimepivv4" && type === "smartcard";

    if (!type || !serial) {
        return null;
    }

    const deviceMapping = {
        ...deviceTypes[idprimepivv4Type ? "idprimepivv4": type],
        ...deviceSubTypes[device.subType],
    };
    const deviceString = `d_${type.replace(/[^a-zA-Z0-9_-]/g, '')}-${serial}`;
    const imageTarget = `${deviceString}-img`;
    const { imgLink, imgAlt } = deviceMapping || {};
    const srcImg = imgLink || unknownCredential;
    const altImg = t(imgAlt || 'unknownDevice'); 
    
    return (
        <>
            {!idprimepivv4Type && (
                <StyledImage src={srcImg} id={imageTarget} alt={altImg} />
            )}
            { idprimepivv4Type && (
                <StyledLargeHorizontalImage src={srcImg} id={imageTarget} alt={altImg} />
            )}
        </>
    );
};

export default DeviceType;
